import { Modal } from 'antd'
import { useSelector } from 'react-redux'

import { getUserIdentity } from '~/redux-modules/identity'

const FEEDBACK_URL = 'https://www.getfeedback.com/r/kHDW1cr8'

interface TeamsEarlyAccessSurveyModalPropsType {
    visible: boolean
    onCancel: () => void
    fromShareModal?: boolean
}

const TeamsEarlyAccessSurveyModal = ({
    visible,
    onCancel,
    fromShareModal = false,
}: TeamsEarlyAccessSurveyModalPropsType) => {
    const identity = useSelector(getUserIdentity)

    return (
        <Modal
            bodyStyle={{ padding: 0, height: '634px' }}
            centered
            closable
            footer={null}
            onCancel={onCancel}
            style={{ top: fromShareModal ? '-34px' : '0px' }}
            title="Try Fictiv Premium"
            visible={visible}
            width="634px"
        >
            <iframe
                data-test-target="teams-early-access-survey-modal-iframe"
                src={`${FEEDBACK_URL}?&email=${identity.email}`}
                style={{
                    border: 0,
                    height: '100%',
                    width: '100%',
                    borderRadius: '4px',
                }}
            />
        </Modal>
    )
}

export default TeamsEarlyAccessSurveyModal
